import * as React from 'react';

import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import { cn, humanReadableShortPricingUnit } from '@rematter/ui-web';

import { SelectEnum } from '~/shared/components/select-fields/SelectEnum';

export interface UnitFieldCellProps {
  value: Unit;
  onChange: (value?: Unit) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
  formatLabel?: (value: Unit) => string;
}

export const UnitFieldCell: React.FC<UnitFieldCellProps> = ({
  value,
  onChange,
  disabled = false,
  className,
  error,
  formatLabel = humanReadableShortPricingUnit,
}) => (
  <SelectEnum
    enumValue={enumUnit}
    formatOptionLabel={formatLabel}
    value={value}
    onChange={onChange}
    isDisabled={disabled}
    errorMessage={error}
    className={cn('@UnitFieldCell', className)}
  />
);
